'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('moment/locale/pt-br');

var _pt_BR = require('rc-pagination/lib/locale/pt_BR');

var _pt_BR2 = _interopRequireDefault(_pt_BR);

var _pt_BR3 = require('../date-picker/locale/pt_BR');

var _pt_BR4 = _interopRequireDefault(_pt_BR3);

var _pt_BR5 = require('../time-picker/locale/pt_BR');

var _pt_BR6 = _interopRequireDefault(_pt_BR5);

var _pt_BR7 = require('../calendar/locale/pt_BR');

var _pt_BR8 = _interopRequireDefault(_pt_BR7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_moment2["default"].locale('pt-br');
exports["default"] = {
    locale: 'pt-br',
    Pagination: _pt_BR2["default"],
    DatePicker: _pt_BR4["default"],
    TimePicker: _pt_BR6["default"],
    Calendar: _pt_BR8["default"],
    Table: {
        filterTitle: 'Filtro',
        filterConfirm: 'OK',
        filterReset: 'Resetar',
        emptyText: 'Não há dados'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancelar',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancelar'
    },
    Transfer: {
        notFoundContent: 'Não encontrado',
        searchPlaceholder: 'Procurar',
        itemUnit: 'item',
        itemsUnit: 'items'
    },
    Select: {
        notFoundContent: 'Não encontrado'
    }
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/pt_BR.tsx
 ** module id = 783
 ** module chunks = 1
 **/